var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.checkPermission(["chartView_student_status_and_attendance"])
    ? _c("div", { staticClass: "card-wrapper" }, [
        _c("div", { staticClass: "card-top" }, [
          _c("div", { staticClass: "card-header" }, [
            _c("div", { staticClass: "card-heading" }, [
              _vm._m(0),
              _c("div", [
                _c("p", { staticClass: "card-title" }, [
                  _vm._v("Tình trạng điểm danh"),
                ]),
                _c("p", { staticClass: "card-subtitle" }, [
                  _vm._v(_vm._s(_vm.periodLabel)),
                ]),
                _c("div", { staticClass: "header-tags" }, [
                  _c("span", { staticClass: "header-tag" }, [
                    _vm._v("Tổng lượt: " + _vm._s(_vm.totalRecords)),
                  ]),
                  _c("span", { staticClass: "header-tag header-tag--soft" }, [
                    _vm._v(_vm._s(_vm.activeSummaryLabel)),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm.loaded && _vm.summaryItems.length
            ? _c(
                "div",
                { staticClass: "summary-row" },
                _vm._l(_vm.summaryItems, function (item) {
                  return _c(
                    "div",
                    {
                      key: item.label,
                      staticClass: "summary-card",
                      style: { "--summary-accent": item.color },
                    },
                    [
                      _c("span", { staticClass: "summary-label" }, [
                        _vm._v(_vm._s(item.label)),
                      ]),
                      _c("strong", { staticClass: "summary-value" }, [
                        _vm._v(_vm._s(item.value)),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "chart-shell" }, [
          _vm.isLoading
            ? _c("div", { staticClass: "chart-content" }, [_vm._m(1)])
            : _vm.loaded && _vm.hasData
            ? _c("div", { staticClass: "chart-content" }, [
                _c("div", { staticClass: "chartFees" }, [
                  _vm._m(2),
                  _c(
                    "div",
                    { staticClass: "chartAttendace" },
                    [
                      _c("ChartLine", {
                        attrs: {
                          chartData: _vm.dataConnection.chartData,
                          options: _vm.dataConnection.options,
                          height: 340,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ])
            : _c("div", { staticClass: "chart-content chart-empty" }, [
                _vm._m(3),
              ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-icon" }, [
      _c("i", { staticClass: "el-icon-date" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state-card state-card--loading" }, [
      _c("i", { staticClass: "el-icon-loading state-icon" }),
      _c("div", [
        _c("p", { staticClass: "state-title" }, [
          _vm._v("Đang tải dữ liệu biểu đồ"),
        ]),
        _c("span", { staticClass: "state-text" }, [
          _vm._v("Hệ thống đang tổng hợp dữ liệu điểm danh theo thời gian."),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chart-caption" }, [
      _c("span", { staticClass: "chart-caption__dot" }),
      _c("span", [
        _vm._v(
          "Biểu đồ đường theo dõi biến động điểm danh trong khoảng thời gian đã chọn"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state-card state-card--empty" }, [
      _c("i", { staticClass: "el-icon-document-delete state-icon" }),
      _c("div", [
        _c("p", { staticClass: "state-title" }, [
          _vm._v("Chưa có dữ liệu điểm danh"),
        ]),
        _c("span", { staticClass: "state-text" }, [
          _vm._v(
            "Khi có bản ghi điểm danh trong khoảng thời gian này, biểu đồ sẽ hiển thị tại đây."
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }